import { render } from "./TopicInfo.vue?vue&type=template&id=16a834a8"
import script from "./TopicInfo.vue?vue&type=script&lang=js"
export * from "./TopicInfo.vue?vue&type=script&lang=js"

import "./TopicInfo.vue?vue&type=style&index=0&id=16a834a8&lang=css"
script.render = render

export default script